export default {
  ZONE_SET: 'ZONE_SET',
};
